import React, { FC, useRef } from 'react';

import { Button, Flex, Heading, Text } from '@chakra-ui/react';

import { MdGroupAdd } from 'react-icons/md';

import {
  AddCustomerModal,
  AddCustomerModalRef,
} from 'components/modules/AddCustomerModal';
import {
  EditCustomerModal,
  EditCustomerModalRef,
} from 'components/modules/EditCustomerModal';
import { UserPill } from 'components/core/UserPill';
import { CustomTable } from 'components/modules/CustomTable';

import { CustomersViewProps } from './Customers.props';
import { washhubSelector } from 'store/slices/washhub';
import { useAppSelector } from 'store/hooks';
import { convertUTCToLocal } from 'utils/dateUtils';

const CustomersView: FC<CustomersViewProps> = (props) => {
  const { customers, isLoading, isDeleting, pagination, onDelete } = props;

  const addCustomerModalRef = useRef<AddCustomerModalRef>(null);
  const editCustomerModalRef = useRef<EditCustomerModalRef>(null);

  const onCreateCustomer = () => {
    addCustomerModalRef?.current?.onOpen?.();
  };
  const washHubs = useAppSelector(washhubSelector);

  const getWashHubByID = (washID?: string) => {
    let washHubById = '';

    if (!Boolean(washID)) return (washHubById = ' - ');

    const washHub = washHubs.find((wash) => wash?._id === washID);
    washHubById = washHub?.name || ' - ';
    return washHubById;
  };

  return (
    <Flex flex={1} direction="column" color="support.500" overflow="auto">
      <Flex alignItems="baseline" justify="space-between">
        <Heading mb={6} fontSize="24px">
          Customers
        </Heading>
        <Flex align="flex-end">
          <Button
            mr={2}
            minW="200px"
            leftIcon={<MdGroupAdd size="20px" />}
            onClick={onCreateCustomer}>
            Create Customer
          </Button>
          <UserPill />
        </Flex>
      </Flex>
      <Flex h="50px" />
      <CustomTable
        type="customers"
        data={customers}
        isLoading={isLoading}
        minW="1600px"
        isDeleting={isDeleting}
        onDelete={onDelete}
        pagination={pagination}>
        {{
          headerRow: (
            <>
              <Text flex={0.8}>Company Name</Text>
              <Text flex={1}>Type</Text>
              <Text flex={1}>Wash Hub</Text>
              <Text flex={0.5}>Status</Text>
              <Text flex={1}>Dates</Text>
              <Text flex={0.5}>Billing Contact</Text>
            </>
          ),
          renderRow: (customer) => (
            <Flex
              flex={1}
              onClick={() => {
                editCustomerModalRef?.current?.onOpen?.(customer);
              }}>
              <Text flex={0.8}>{customer?.companyName || '-'}</Text>
              <Text flex={1}>{customer?.type || '-'}</Text>
              <Text flex={1}>
                {getWashHubByID(customer?.permissions?.[0].washHub)}
              </Text>
              <Text flex={0.5}>{customer?.status}</Text>
              <Text flex={1}>
                {convertUTCToLocal(customer?.createdAt, true)}
              </Text>
              <Text flex={0.5}>{customer?.billingContact}</Text>
            </Flex>
          ),
        }}
      </CustomTable>
      <AddCustomerModal ref={addCustomerModalRef} />
      <EditCustomerModal ref={editCustomerModalRef} />
    </Flex>
  );
};

export default CustomersView;
